var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 8.68421,
    fill: "#A168E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2155_2227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.63086,
    y: 4,
    width: 13.8947,
    height: 13.8947,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2155_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79047 16.223C9.5067 16.5068 9.04661 16.5068 8.76284 16.223C8.47907 15.9393 8.47907 15.4792 8.76284 15.1954L13.0109 10.9474L8.76284 6.69934C8.47907 6.41557 8.47907 5.95549 8.76284 5.67171C9.04661 5.38794 9.5067 5.38794 9.79047 5.67171L14.6568 10.538C14.8828 10.7641 14.8828 11.1307 14.6568 11.3567L9.79047 16.223Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow2);
export default __webpack_public_path__ + "static/media/nextArrow2.83ce1229778da8687a948019cf12c9ae.svg";
export { ForwardRef as ReactComponent };